<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :auto-fetch="false"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      serial-width="100"
      :selection="hasBtn && selection"
      :stripe="false"
      right-toolbar-hide
      :hide-search="hideSearch"
      row-key="id"
      :reset-data="resetDataFn"
      tree-select-auto-parent
      lazy
      :load="loadMethod"
      :row-style="$treeRowStyleFun"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Receiving')" prop="receiveStatus">
            <BjSelectLov
              v-model="queryParams.receiveStatus"
              constant-key="ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST"
            />
          </el-form-item>
        </el-col>
        <template v-if="businessType == ORDER_BUSINESS_TYPES.COMMON">
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Shipment')" prop="deliveryStatus">
              <BjSelectLov
                v-model="queryParams.deliveryStatus"
                constant-key="ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #ifndef OPEN-SOURCE -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.occupied')" prop="preemptionStatus">
              <BjSelectLov
                v-model="queryParams.preemptionStatus"
                constant-key="ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Sourcing')" prop="sourceStatus">
              <BjSelectLov
                v-model="queryParams.sourceStatus"
                constant-key="ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.status')" prop="suspendStatus">
              <BjSelectLov
                v-model="queryParams.suspendStatus"
                constant-key="ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #ifndef OPEN-SOURCE -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.Write')" prop="syncPreempStatus">
              <BjSelectLov
                v-model="queryParams.syncPreempStatus"
                constant-key="ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
          <!-- #endif -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.GoodsInfoTab.update')" prop="syncDeliveryStatus">
              <BjSelectLov
                v-model="queryParams.syncDeliveryStatus"
                constant-key="ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST"
              />
            </el-form-item>
          </el-col>
        </template>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <template v-else-if="col.prop === 'tags'">
                <BjTagList :tag-code-string="scope.row.tags" />
              </template>

              <!-- <template v-else-if="col.prop === 'spuName'">
                <el-tag v-if="scope.row.setFlag == 1">{{ $t('OrdinaryOrderMix.GoodsInfoTab.Oo') }}</el-tag>

                {{ scope.row[col.prop] }}
              </template> -->

              <template v-else-if="col.prop === 'giftFlag'">
                <el-tag :type="scope.row.giftFlag ? 'success' : 'info'">{{
                  $t(STATUS_YES_NUM.bjGet(!!scope.row.giftFlag))
                }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'refundFlag'">
                <el-tag :type="scope.row.refundFlag ? 'success' : 'info'">{{
                  $t(STATUS_YES_NUM.bjGet(!!scope.row.refundFlag))
                }}</el-tag>
              </template>

              <template
                v-else-if="
                  col.prop.toLocaleLowerCase().includes('amount') ||
                    col.prop.toLocaleLowerCase().includes('price')
                "
              >
                {{ $number2money(scope.row[col.prop]) }}
              </template>

              <template v-else-if="col.prop === 'deliveryStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'receivingStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <!-- #ifndef OPEN-SOURCE -->
              <template v-else-if="col.prop === 'preemptionStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'sourceStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'syncPreempStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <!-- #endif -->
              <template v-else-if="col.prop === 'suspendStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <template v-else-if="col.prop === 'syncDeliveryStatus'">
                {{
                  $t([
                    ...ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
                    ...ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
                  ].bjGet(scope.row[col.prop]))
                }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="onDetail(scope.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  ORDER_INTERNAL_ORDER_STATUS_LIST,
  // #ifndef OPEN-SOURCE
  ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
  // #endif
  ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
  ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
  ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
  ORDER_BUSINESS_TYPES,
} from '@/utils/constants';

export default {
  name: 'BusinessOrderInternalViewSkuList',
  components: {},
  mixins: [pageMiXin],
  props: {
    orderId: {
      type: String,
      default: null,
    },
    hasBtn: {
      type: Boolean,
      default: true,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    businessType: {
      type: String,
      default: ORDER_BUSINESS_TYPES.COMMON,
    },
  },
  data() {
    return {
      serial: true,
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_ORDER_STATUS_LIST,
      // #ifndef OPEN-SOURCE
      ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST,
      // #endif
      ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST,

      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST,
      ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST,
      ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST,
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
      ORDER_BUSINESS_TYPES,
      queryApi: orderApi.getInternalSkuListByOrder,
      // 查询参数
      queryParams: {
        deliveryStatus: null,
        isOutStock: null,
        refundFlag: null,
        orderId: null,
        preemptionStatus: null,
        receiveStatus: null,
        sourceStatus: null,
        suspendStatus: null,
        syncDeliveryStatus: null,
        syncPreempStatus: null,
      },
      labelsVersion: 11,
      tableSortableDisabled: true,

      selectedRows: null,
    };
  },
  computed: {
    labelList() {
      const ARR = [
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Label'), prop: 'tags', isCheck: true, disabled: false, width: 97 },
        // { label: this.$t('goodsPage.spuName'), prop: 'spuName', isCheck: true, disabled: false, width: 160 },
        // { label: this.$t('goodsPage.spuCode'), prop: 'spuCode', isCheck: true, disabled: false, width: 160 },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.SKU'), prop: 'skuCode', isCheck: true, disabled: false, width: 107 },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Giveaway'), prop: 'giftFlag', isCheck: true, disabled: false, width: 125 },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Quantity'), prop: 'quantity', isCheck: true, disabled: false, width: '81' },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.platform'), prop: 'thirdSaleAmount', isCheck: true, disabled: false, width: '151' },
        // { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.total'), prop: 'outBalancePrice', isCheck: true, disabled: false, width: '162' },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.sales'), prop: 'innerSalePrice', isCheck: true, disabled: false, width: '105' },
        // { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.average'), prop: 'innerBalancePrice', isCheck: true, disabled: false, width: '122' },
        // { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Cost'), prop: 'costAmount', isCheck: true, disabled: false, width: '113' },
        // { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Totalf'), prop: 'totalCostAmount', isCheck: true, disabled: false, width: '80' },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Freight'), prop: 'transPrice', isCheck: true, disabled: false, width: '74' },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Shipment'), prop: 'deliveryStatus', isCheck: true, disabled: false, width: '119' },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Receiving'), prop: 'receivingStatus', isCheck: true, disabled: false, width: '126' },
        // #ifndef OPEN-SOURCE
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.occupied'), prop: 'preemptionStatus', isCheck: true, disabled: false, width: '151' },
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Sourcing'), prop: 'sourceStatus', isCheck: true, disabled: false, width: '159' },
        // #endif
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Pending'), prop: 'suspendStatus', isCheck: true, disabled: false, width: '198' },
        // #ifndef OPEN-SOURCE
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.Write'), prop: 'syncPreempStatus', isCheck: true, disabled: false, width: '164' },
        // #endif
        { label: this.$t('OrdinaryOrderMix.GoodsInfoTab.update'), prop: 'syncDeliveryStatus', isCheck: true, disabled: false, width: '170' },
      ];
      if (this.businessType == ORDER_BUSINESS_TYPES.O2O) {
        ARR.forEach(col => {
          if (col.prop == 'receivingStatus') {
            col.width = 'auto';
          }
          if (col.width == '74') {
            col.width = '128';
          }
          if (col.width < 100) {
            col.width = '100';
          }
        });

        const NOT_IN_O2O_STR =
          'deliveryStatus,preemptionStatus,sourceStatus,suspendStatus,syncPreempStatus,syncDeliveryStatus';
        NOT_IN_O2O_STR.split(',').forEach(key => {
          const INDEX = ARR.findIndex(col => col.prop == key);
          if (INDEX > -1) {
            ARR.splice(INDEX, 1);
          }
        });
      }
      return ARR;
    },
  },
  watch: {
    orderId: {
      handler(v) {
        if (v) {
          console.warn('SkuList', v);
          this.queryParams.orderId = v;
          this.$nextTick(() => {
            this.reFresh();
          });
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {
    resetDataFn(data) {
      return data.map(e => {
        return { BJ_HAS_CHILD: true, BJ_PARENT_ID: null, ...e };
      });
    },
    loadMethod({ row }) {
      // 异步加载子节点
      return new Promise((resolve, reject) => {
        orderApi
          .getInternalSkuLineListBySku({
            itemId: row.id,
          })
          .then(res => {
            const TEMP = (Array.isArray(res) ? res : []).map(e => {
              return { ...e, BJ_HAS_CHILD: false, BJ_PARENT_ID: row.id };
            });

            if (TEMP.length) {
              resolve(TEMP);
            } else {
              this.$message.warning(this.$t('OrdinaryOrderMix.GoodsInfoTab.back'));
              reject();
            }
          });
      });
    },
    handleSelectionChange(data) {
      this.selectedRows = data;
    },
  },
};
</script>
